/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * The layer to place blocks on.
 *
 * @internal
 */
export const BLOCK = 50;

/**
 * The layer to place bubbles on.
 *
 * @internal
 */
export const BUBBLE = 100;
